/**
 * External dependencies.
 */
import React from 'react';

/**
 * DropdownIcon Component.
 *
 * @return {jsx}
 */
const DropdownIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<g fill="none" fillRule="evenodd">
			<g stroke="#000">
				<g>
					<g>
						<path d="M10.5 9L13.5 12 10.5 15" transform="translate(-276 -99) translate(0 81) translate(276 18) rotate(90 12 12)"/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default DropdownIcon;
